var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_c('p',[_vm._v("Access Forbidden, you can't access this functionality.")]),_c('p',[_vm._v("Please click on logout & login again as company user")]),_c('el-button',{staticClass:"mt-1",attrs:{"type":"primary"},on:{"click":_vm.logoutUser}},[_vm._v("Logout")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }